import { platformInfo, DeviceInfoPlatform } from './device.constants';
import { getDeviceInfo } from './getDeviceInfo';
import { getOsInfo } from './getOSInfo';

export async function calculatePlatform(userAgent: string, deviceId: string): Promise<void> {
  const deviceInfo = getDeviceInfo(userAgent);
  const osInfo = await getOsInfo(userAgent);

  platformInfo.deviceId = deviceId;

  platformInfo.osName = osInfo.osName;
  platformInfo.osVersion = osInfo.osVersion;

  platformInfo.device = deviceInfo.device;
  platformInfo.isMobile = deviceInfo.isMobile;
  platformInfo.isTablet = deviceInfo.isTablet;
  platformInfo.isSafari = deviceInfo.isSafari;
  platformInfo.isFF = deviceInfo.isFF;
  platformInfo.isChrome = deviceInfo.isChrome;
  platformInfo.isElectron = deviceInfo.isElectron;

  if (platformInfo.isElectron) {
    platformInfo.platform = DeviceInfoPlatform.Desktop;
    platformInfo.device = window.electronAPI.device;
    platformInfo.osVersion = window.electronAPI.osVersion;
  }
}
